import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ErrorHandler } from "./Xt/Layout/ErrorHandler";
// import  '@progress/kendo-theme-default/dist/all.css';


ReactDOM.render(
    <React.StrictMode>
        <ErrorHandler>
            <App />
        </ErrorHandler>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
